import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/analytics';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../../../hooks/use-product-view-history.js';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { WITH_RX, WITHOUT_RX } from '../../../../../components/RxableSelect/contants.js';
import '../../../../types/quantity-discounts.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { CLRxableSelect } from './CLRxableSelect.js';

const CLRxableSelectContainer = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { actions , state  } = useCLEcommContext();
    const { rxToggle: rxToggle1  } = state.configurations;
    const radioButtonItems = [
        {
            value: WITH_RX,
            label: getLabel('products.selectRxAble.contactLens.withRx')
        },
        {
            value: WITHOUT_RX,
            label: getLabel('products.selectRxAble.contactLens.withoutRx')
        }, 
    ];
    const onRxRadioChange = React.useCallback((rxToggle)=>{
        actions.updateRxToggleSelection(rxToggle);
    }, [
        actions
    ]);
    return /*#__PURE__*/ React.createElement(CLRxableSelect, {
        items: radioButtonItems,
        onChange: onRxRadioChange,
        selectedValue: rxToggle1,
        className: className
    });
};

export { CLRxableSelectContainer };
//# sourceMappingURL=CLRxableSelectContainer.js.map
